import { render, staticRenderFns } from "./IconSvgIconBee.vue?vue&type=template&id=9d78c608&scoped=true&"
import script from "./IconSvgIconBee.vue?vue&type=script&lang=js&"
export * from "./IconSvgIconBee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d78c608",
  null
  
)

export default component.exports